if (!customElements.get('mobile-rail')) {
  customElements.define('mobile-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-mobile-rail]'); this.items = [...(this.rail?.children || [])]; this.dots = [...this.querySelectorAll('[data-rail-dot]')];
      if (!this.rail || this.items.length < 2) return;
      this.lockAxis();
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.items[index]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'})));
      this.onScroll = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => { const left=this.rail.getBoundingClientRect().left; let active=0,distance=Infinity; this.items.forEach((item,index)=>{const value=Math.abs(item.getBoundingClientRect().left-left);if(value<distance){distance=value;active=index;}}); this.dots.forEach((dot,index)=>{dot.classList.toggle('is-active',index===active);dot.setAttribute('aria-current',index===active?'true':'false');}); }); };
      this.rail.addEventListener('scroll', this.onScroll, {passive:true});
    }
    lockAxis() {
      this.onTouchStart = (event) => {
        const touch = event.touches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
        this.railStartX = this.rail.scrollLeft;
        this.gestureAxis = null;
      };
      this.onTouchMove = (event) => {
        const touch = event.touches[0];
        const deltaX = Math.abs(touch.clientX - this.touchStartX);
        const deltaY = Math.abs(touch.clientY - this.touchStartY);
        if (!this.gestureAxis && Math.max(deltaX, deltaY) > 7) this.gestureAxis = deltaY > deltaX * 1.1 ? 'vertical' : 'horizontal';
        if (this.gestureAxis === 'vertical' && this.rail.scrollLeft !== this.railStartX) this.rail.scrollLeft = this.railStartX;
      };
      this.onTouchEnd = () => { this.gestureAxis = null; };
      this.rail.addEventListener('touchstart', this.onTouchStart, {passive:true});
      this.rail.addEventListener('touchmove', this.onTouchMove, {passive:true});
      this.rail.addEventListener('touchend', this.onTouchEnd, {passive:true});
      this.rail.addEventListener('touchcancel', this.onTouchEnd, {passive:true});
    }
    disconnectedCallback(){
      this.rail?.removeEventListener('scroll',this.onScroll);
      this.rail?.removeEventListener('touchstart',this.onTouchStart);
      this.rail?.removeEventListener('touchmove',this.onTouchMove);
      this.rail?.removeEventListener('touchend',this.onTouchEnd);
      this.rail?.removeEventListener('touchcancel',this.onTouchEnd);
      cancelAnimationFrame(this.frame);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-axis-lock]').forEach((rail) => {
    let startX = 0, startY = 0, startScroll = 0, axis = null;
    rail.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      startX = touch.clientX; startY = touch.clientY; startScroll = rail.scrollLeft; axis = null;
    }, {passive:true});
    rail.addEventListener('touchmove', (event) => {
      const touch = event.touches[0];
      const dx = Math.abs(touch.clientX - startX), dy = Math.abs(touch.clientY - startY);
      if (!axis && Math.max(dx, dy) > 7) axis = dy > dx * 1.1 ? 'vertical' : 'horizontal';
      if (axis === 'vertical' && rail.scrollLeft !== startScroll) rail.scrollLeft = startScroll;
    }, {passive:true});
    rail.addEventListener('touchend', () => { axis = null; }, {passive:true});
    rail.addEventListener('touchcancel', () => { axis = null; }, {passive:true});
  });
});
